import { GAME_ID, LEVEL_COUNT, REDUX_ACTIONS } from '../../data/constants';

const initialState = {
  highestLevelEarned: 0,
  hasCompletedOnboarding: false,
  schemasUnlocked: {},
  questionIdsCorrect: [],
  createStoryResponses: {},
  createdStoriesSortedCount: 0,
};

const gameProgressReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.LEVEL_MASTERED: {
      return {
        ...state,
        highestLevelEarned: Math.min(payload + 1, LEVEL_COUNT - 1),
      };
    }

    case REDUX_ACTIONS.ROUND_END: {
      return {
        ...state,
        questionIdsCorrect: [],
        createStoryResponses: {},
        createdStoriesSortedCount: 0,
      };
    }

    case REDUX_ACTIONS.SELECT_FILL_IN_BLANK_RESPONSE: {
      const { storyId, fillInBlankId, response } = payload;
      const storyResponses = { ...state.createStoryResponses[storyId] };
      storyResponses[fillInBlankId] = response;

      return {
        ...state,
        createStoryResponses: {
          ...state.createStoryResponses,
          [storyId]: storyResponses,
        },
      };
    }

    case REDUX_ACTIONS.SELECT_RESPONSE: {
      const { isFirstAttempt, isCorrect, questionId, isCreatedSort } = payload;
      // Response only gets "correct" credit if its the users first try on this question (in tihs round)
      if (isFirstAttempt && isCorrect) {
        if (isCreatedSort) {
          return {
            ...state,
            createdStoriesSortedCount: state.createdStoriesSortedCount + 1,
          };
        }
        const questionIdsCorrect = [...state.questionIdsCorrect];
        questionIdsCorrect.push(questionId);
        return {
          ...state,
          questionIdsCorrect,
        };
      }
      return state;
    }

    case REDUX_ACTIONS.SCHEMA_UNLOCKED: {
      const schemaId = payload;
      return {
        ...state,
        schemasUnlocked: {
          ...state.schemasUnlocked,
          [schemaId]: true,
        },
      };
    }

    default:
      return state;
  }
};

export default gameProgressReducer;
